import React from "react";
import { Modal, ModalBody } from "reactstrap";

interface DeleteModalProps {
  show?: boolean;
  onDeleteClick?: () => void;
  onCloseClick?: () => void;
  recordId?: string;
  text?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  show = false,
  onDeleteClick,
  onCloseClick,
  recordId,
  text,
}) => {
  const renderIcon = () => {
    if (text) {
      return text === "Activate" ? (
        <i className="ri-user-line display-5" style={{ color: "green" }}></i>
      ) : (
        <i className="ri-user-forbid-line display-5" style={{ color: "red" }}></i>
      );
    }
    return <i className="ri-delete-bin-line display-5 text-danger"></i>;
  };

  return (
    <Modal fade isOpen={show} toggle={onCloseClick} centered>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          {renderIcon()}

          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            {text ? (
              <p className="mx-4 mb-0">Are you sure you want to {text} this user?</p>
            ) : (
              <p className="text-muted mx-4 mb-0">
                Are you sure you want to remove this record {recordId || ""}?
              </p>
            )}
          </div>
        </div>

        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light material-shadow-none"
            onClick={onCloseClick}
          >
            Close
          </button>

          <button
            type="button"
            className="btn w-sm btn-danger material-shadow-none"
            onClick={onDeleteClick}
          >
            {text ? `Yes, ${text}` : "Yes, Delete It!"}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
